export const graphQLEndpoint = "https://server.fitplannerhub.org/graphql";
export const authEndpoint = "https://server.fitplannerhub.org/auth";
// export const graphQLEndpoint = "http://localhost:8080/graphql";
// export const authEndpoint = "http://localhost:8080/auth";